/**
 * Tradedoubler "Grow" landing tag.
 *
 * Loads the Tradedoubler conversion SDK on every page so the first-party
 * attribution cookie can be set when a visitor arrives from an affiliate link.
 * The actual "sale" conversion is reported separately from the Shopify
 * Customer Events custom pixel (the checkout/thank-you page cannot run this SDK).
 */
(function (w, d) {
    var ORG = "2471702"; // Tradedoubler organisation id (Grow account)
    var PROG = "402900"; // Tradedoubler program id (Grow account)

    function getUrlParameter(key) { // Read a querystring parameter by name
        var m = new RegExp("[\\?&]" + key + "=([^&#]*)").exec(w.location.search);
        return m === null ? "" : decodeURIComponent(m[1].replace(/\+/g, " "));
    }

    function setCookie(name, value) { // Persist the affiliate click id as a first-party cookie (~1 year)
        var host = w.location.host;
        var domain = "." + host.split(".").slice(-2).join("."); // Best-effort root domain
        var exp = new Date();
        exp.setTime(exp.getTime() + 31536e6); // ~1 year in ms
        d.cookie =
            name + "=" + encodeURIComponent(value) +
            ";expires=" + exp.toUTCString() +
            ";domain=" + domain +
            ";path=/" +
            ";SameSite=None" +
            ";Secure";
    }

    var tdclid = getUrlParameter("tdclid_sn"); // Affiliate click id
    if (tdclid) setCookie("tdclid_sn", tdclid);

    // Official Tradedoubler async SDK loader (landing tag from the Grow guide).
    (function (i, s, o, g, r, a, m) {
        i["TDConversionObject"] = r;
        i[r] = i[r] || function () { (i[r].q = i[r].q || []).push(arguments); };
        i[r].l = 1 * new Date();
        a = s.createElement(o);
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(
        w,
        d,
        "script",
        "https://svht.tradedoubler.com/tr_sdk.js?org=" + ORG + "&prog=" + PROG + "&dr=true&rand=" + Math.random(),
        "tdconv"
    );
})(window, document);
